import React, { Component } from "react";
import styles from "./style.module.scss";
import Header from "components/Header";
import Footer from "components/Footer";
import UnderlinedLink from "components/UnderlinedLink";
import SEO from "components/SEO";
import crystalPreviewImg from "assets/crystal/crystal-kvis_small.png";
import crystalLogo from "assets/crystal/Crystal_Glyph_Color.png";
import crystalVideo from "assets/crystal/crystal_intro_video.mp4";
import videoThumbnail from "assets/crystal/video_thumbnail.png";
import RequestDemoForm from "../../components/RequestDemoForm";

const title = "crystal";
const description = "crystal, created by iGenius";

class CrystalPage extends Component {
  constructor() {
    super();
    this.state = {
      showVideo: false,
    };
  }
  render() {
    const { showVideo } = this.state;
    return (
      <div className={styles.CrystalPage}>
        <SEO
          title={title}
          description={description}
          url="https://igenius.ai/crystal"
        />

        <Header />

        <section className={`row ${styles.content}`}>
          <div className="col-12 col-xl-5 font-body">
            <img src={crystalLogo} width={94} alt="logo of crystal" />
            <h1 className="font-tt2 margin-top-24">Ask your way</h1>
            <h1 className="font-tt2 margin-bottom-56">to better decisions</h1>
            <p
              className={`font-color-grey margin-bottom-56 ${
                styles.bodyLineHeight
              }`}
            >
              Bridge the data skills gap like never before: expand access to
              business data and the ability to make data-driven decisions every
              day to everyone in your business with crystal, the virtual advisor
              for data intelligence created by iGenius.
            </p>
            <UnderlinedLink
              label="Book a Demo"
              greenLine
              liftAnimation
              externalLink
              active
              onClick={(e) => {
                e.preventDefault();
                this.props.openRequestDemoForm();
              }}
            />
          </div>
          <div className="col-12 col-xl-6 offset-xl-1 d-flex justify-content-center margin-top-32">
            <img src={crystalPreviewImg} />
          </div>
          <div className=" col-12 margin-top-104 margin-bottom-104">
            {showVideo && (
              <video controls autoPlay>
                <source src={crystalVideo} type="video/mp4" />
              </video>
            )}
            {!showVideo && (
              <div
                className={styles.thumbnailWrapper}
                onClick={() => this.setState({ showVideo: true })}
              >
                <img src={videoThumbnail} />
                <div
                  className={`font-body font-color-white ${styles.playButton}`}
                >
                  Meet crystal
                  <svg
                    width="22"
                    height="24"
                    viewBox="0 0 22 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.2399 2.95996C5.6821 2.96344 6.11598 3.08052 6.4999 3.29996L17.7799 9.81996C18.1619 10.0415 18.4789 10.3594 18.6994 10.742C18.9198 11.1246 19.0358 11.5584 19.0358 12C19.0358 12.4415 18.9198 12.8753 18.6994 13.2579C18.4789 13.6405 18.1619 13.9585 17.7799 14.18L6.4999 20.7C6.11598 20.9194 5.6821 21.0365 5.2399 21.04C4.56972 21.0347 3.92879 20.7648 3.45676 20.289C2.98474 19.8132 2.71988 19.1702 2.7199 18.5V5.49996C2.71988 4.82976 2.98474 4.18672 3.45676 3.71095C3.92879 3.23517 4.56972 2.96524 5.2399 2.95996V2.95996ZM5.2399 0.959961C4.64464 0.959955 4.05524 1.07753 3.50554 1.30593C2.95584 1.53433 2.45667 1.86906 2.03668 2.2909C1.6167 2.71274 1.28418 3.21339 1.05821 3.76409C0.832234 4.31479 0.717264 4.90471 0.719898 5.49996V18.5C0.69824 19.303 0.891935 20.0972 1.28087 20.8C1.66981 21.5029 2.2398 22.0889 2.93168 22.497C3.62355 22.9052 4.41208 23.1208 5.21539 23.1213C6.0187 23.1218 6.8075 22.9073 7.4999 22.5L18.7799 16C19.4696 15.604 20.0427 15.0331 20.4412 14.3448C20.8397 13.6565 21.0496 12.8753 21.0496 12.08C21.0496 11.2846 20.8397 10.5034 20.4412 9.81513C20.0427 9.12686 19.4696 8.55592 18.7799 8.15996L7.4999 1.65996C6.81492 1.25643 6.0349 1.04244 5.2399 1.03996V0.959961Z"
                      fill="#F7F9FF"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
          <div className="col-12 col-xl-6 margin-bottom-144 font-body">
            <h1 className="font-tt2 margin-bottom-32">
              Make every decision data-driven
            </h1>
            <p
              className={`font-color-grey margin-bottom-56 ${
                styles.bodyLineHeight
              }`}
            >
              Start talking with crystal, the virtual colleague that advises you
              through your business data and guides you from insights to
              actions.
            </p>
            <UnderlinedLink
              label="Go to crystal"
              active
              newTab
              greenLine
              liftAnimation
              externalLink
              path="https://crystal.ai"
            />
          </div>
        </section>
        <RequestDemoForm />
        <Footer />
      </div>
    );
  }
}

CrystalPage.propTypes = {};

export default CrystalPage;



// WEBPACK FOOTER //
// ./src/pages/crystal/template.js